import {
  AvailableCoursesContent,
  SubjectHeading,
  TargetSubjectsContainer,
} from 'components/credits/credit-items/TargetSubjectsSection/components';

import AndContainer from 'components/common/AndContainer';
import { CreditPointsSection } from 'components/credits/credit-items/CreditPointsSection';
import { CreditType } from 'types/credit';
import FlexContainer from 'components/common/FlexContainer';
import InstitutionCaption from 'components/common/InstitutionCaption';
import { Precedent } from 'types/precedent';
import { getTotalCreditPoints } from 'utils/precedent';
import { interpolate } from 'utils/interpolate';
import useTranslation from 'hooks/use-translation';

type Props = {
  precedent: Precedent;
};

export default function TargetSubjectsSection(props: Props): JSX.Element {
  const { precedent } = props;
  const translation = useTranslation();
  return (
    <TargetSubjectsContainer className='target-subjects-list'>
      <FlexContainer gap={8} flex={1} aria-hidden='true'>
        <FlexContainer gap={4}>
          {precedent.subjects.map((subject, index, array) => (
            <FlexContainer key={subject.ID} gap={4}>
              <SubjectHeading className='target-subject-heading'>
                {translation ? interpolate(translation?.subjectFormat, { name: subject.name, code: subject.code }) : ''}
              </SubjectHeading>
              {index !== array.length - 1 && <AndContainer />}
            </FlexContainer>
          ))}
          <InstitutionCaption />
        </FlexContainer>
        <AvailableCoursesContent courses={precedent.courses} />
      </FlexContainer>
      <CreditPointsSection
        creditItemID={precedent.ID}
        creditPoints={getTotalCreditPoints(precedent)}
        creditType={CreditType.PRECEDENT}
      />
    </TargetSubjectsContainer>
  );
}
